import { AppState } from 'Store'

export const leadsSelector = {
	selectEntries: (state: AppState) => state.new_leads.leads.all.entries,
	selectTotal: (state: AppState) => state.new_leads.leads.all.total_entries,
	selectRequestParams: (state: AppState) => state.new_leads.leads.requestParams,
	getLastLeadId: (state: AppState) => state.new_leads.leads.all.entries[0]?.id,
	getSelectedLeadIds: (state: AppState) => state.new_leads.leads.selectedLeadIds,
}
